import React from 'react';

export default function Logo({ size = 32, className = "" }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M 16 10 L 6 10 C 2 10 2 4 6 4 L 26 4 C 30 4 30 10 26 10 L 16 10 L 16 24 C 16 30 8 30 8 24 C 8 18 12 16 16 16 L 24 16" 
        stroke="url(#threadGradient)" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
      <defs>
        <linearGradient id="threadGradient" x1="2" y1="4" x2="30" y2="30" gradientUnits="userSpaceOnUse">
          <stop stopColor="#34d399" />
          <stop offset="1" stopColor="#10b981" />
        </linearGradient>
      </defs>
    </svg>
  );
}
